export const mySessionsOneToOneLoading =  ({store})  => store.mySessionsOneToOneReducer.loading;

export const mySessionsOneToOneError =  ({store})  => store.mySessionsOneToOneReducer.error;

export const mySessionsOneToOneData =  ({store})  => store.mySessionsOneToOneReducer.data;